<script lang="ts" setup>
// #文字編輯器內容
import { type Text } from '@/utils/types/TextEditor'
const props = defineProps({
  data: {
    type: Object
  }
})

const textData = ref()

if (props.data && props.data.text) {
  const text: Ref<Text> = ref(props.data.text)
  textData.value = text.value
}
</script>

<template>
  <div class="area texteditor" v-html="textData || ''"></div>
</template>

<style lang="scss">
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);
}
</style>
